"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isProd = exports.isLocal = void 0;
const appOrigin = window.location.host;
const strEndsWith = (str, search) => {
    const strLen = str.length;
    return str.substring(strLen - search.length, strLen) === search;
};
const isProd = strEndsWith(appOrigin, '.hotmart.com');
exports.isProd = isProd;
const isLocal = process.env.NODE_ENV === 'development';
exports.isLocal = isLocal;
